export const loader = {
    load: () => ({}),
};
